import PropTypes from "prop-types";
import {roundAmount} from "../utils/money";

const isSignificant = (absAmount, effectiveDecimals) => {
  const x = absAmount * (10 ** effectiveDecimals);
  return (x < 99.5) && (x % 1);
};

const MoneyDisplay = ({amount, decimals, prefix, allowExtraDecimals}) => {
  if (amount === null) return null;
  let effectiveDecimals = decimals;
  if (allowExtraDecimals && amount !== 0) {
    const absAmount = Math.abs(amount);
    const maxDecimals = decimals + 4;
    // three significant digits unless it's zeros
    while ((effectiveDecimals < maxDecimals) && isSignificant(absAmount, effectiveDecimals)) {
      effectiveDecimals++;
    }
  }
  return prefix + roundAmount(amount, effectiveDecimals).toFixed(effectiveDecimals);
};

MoneyDisplay.propTypes = {
  amount: PropTypes.number,
  decimals: PropTypes.number,
  prefix: PropTypes.string,
  allowExtraDecimals: PropTypes.bool,
};

MoneyDisplay.defaultProps = {
  amount: null,
  decimals: 2,
  prefix: '$',
  allowExtraDecimals: false,
};

export default MoneyDisplay;



// WEBPACK FOOTER //
// ./src/common/MoneyDisplay.js